// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";

// // Corrected: The path needs to go up three levels to reach the 'component' directory, then into 'site'.
// import Form from "../../../site/forms/independent/form.jsx";
// import {
//   calculationRules,
//   formFields,
//   formHeading,
//   submitApi,
//   validationRules,
// } from "./module";
// // Corrected: The path needs to go up four levels to reach the 'src' directory, then into 'utils'.
// import { getToken } from "../../../../utils/auth";

// function CustomerForm() {
//   const [data, setData] = useState(null);
//   const { rowId } = useParams();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         if (!rowId) return;
//         const token = getToken();
//         const response = await fetch(`${submitApi}/${rowId}`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (response.ok) {
//           const result = await response.json();
//           setData(result);
//         } else {
//           console.error("API Error:", response.statusText);
//         }
//       } catch (error) {
//         console.error("Network or unexpected error:", error);
//       }
//     };

//     fetchData();
//   }, [rowId, submitApi]); // Added submitApi to dependency array
//   return (
//     <Form
//       formFields={formFields}
//       submitApi={submitApi}
//       formHeading={formHeading}
//       validationRules={validationRules}
//       calculationRules={calculationRules}
//       data={data}
//     />
//   );
// }

// export default CustomerForm;

// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";

// // Corrected: The path needs to go up three levels to reach the 'component' directory, then into 'site'.
// import Form from "../../../site/forms/independent/form.jsx";
// import {
//   calculationRules,
//   formFields,
//   formHeading,
//   submitApi,
//   validationRules,
// } from "./module";
// // Corrected: The path needs to go up four levels to reach the 'src' directory, then into 'utils'.
// import { getToken } from "../../../../utils/auth";

// function CustomerForm() {
//   const [data, setData] = useState(null);
//   const { rowId } = useParams();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         if (!rowId) return;
//         const token = getToken();
//         const response = await fetch(`${submitApi}/${rowId}`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (response.ok) {
//           const result = await response.json();
//           setData(result);
//         } else {
//           console.error("API Error:", response.statusText);
//         }
//       } catch (error) {
//         console.error("Network or unexpected error:", error);
//       }
//     };

//     fetchData();
//   }, [rowId, submitApi]); // Added submitApi to dependency array
//   return (
//     <Form
//       formFields={formFields}
//       submitApi={submitApi}
//       formHeading={formHeading}
//       validationRules={validationRules}
//       calculationRules={calculationRules}
//       data={data}
//     />
//   );
// }

// export default CustomerForm;

// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";

// // The generic Form component that does all the heavy lifting.
// import Form from "../../../site/forms/independent/form.jsx";

// // All form configuration is imported from the module file.
// // When module.js is updated, this component automatically gets the new configuration.
// import {
//   calculationRules,
//   formFields, // This now includes the new vendor_type field configuration.
//   formHeading,
//   submitApi,
//   validationRules,
// } from "./module";

// import { getToken } from "../../../../utils/auth";

// function CustomerForm() {
//   const [data, setData] = useState(null);
//   const { rowId } = useParams();

//   // This useEffect is for fetching data when editing an existing customer.
//   // It remains unchanged.
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         if (!rowId) return;
//         const token = getToken();
//         const response = await fetch(`${submitApi}/${rowId}`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (response.ok) {
//           const result = await response.json();
//           // The result from the API will contain a vendor_type ID (e.g., "1").
//           // The generic Form component will use this ID to pre-select the correct option in the dropdown.
//           setData(result);
//         } else {
//           console.error("API Error:", response.statusText);
//         }
//       } catch (error) {
//         console.error("Network or unexpected error:", error);
//       }
//     };

//     fetchData();
//   }, [rowId]); // Removed submitApi from dependency array as it's a constant string

//   // The component simply passes the imported configuration down to the Form component.
//   // Because 'formFields' was updated in module.js, the Form will render the new field automatically.
//   return (
//     <Form
//       formFields={formFields}
//       submitApi={submitApi}
//       formHeading={formHeading}
//       validationRules={validationRules}
//       calculationRules={calculationRules}
//       data={data}
//     />
//   );
// }

// export default CustomerForm;

// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";

// // The generic Form component that does all the heavy lifting.
// import Form from "../../../site/forms/independent/form";

// // All form configuration is imported from the module file.
// // When module.js is updated, this component automatically gets the new configuration.
// import {
//   calculationRules,
//   formFields, // This now includes the new vendor_type field configuration.
//   formHeading,
//   submitApi,
//   validationRules,
// } from "./module";

// import { getToken } from "../../../../utils/auth";

// function CustomerForm() {
//   const [data, setData] = useState(null);
//   const { rowId } = useParams();

//   // This useEffect is for fetching data when editing an existing customer.
//   // It remains unchanged.
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         if (!rowId) return;
//         const token = getToken();
//         const response = await fetch(`${submitApi}/${rowId}`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (response.ok) {
//           const result = await response.json();
//           // The result from the API will contain a vendor_type ID (e.g., "1").
//           // The generic Form component will use this ID to pre-select the correct option in the dropdown.
//           setData(result);
//         } else {
//           console.error("API Error:", response.statusText);
//         }
//       } catch (error) {
//         console.error("Network or unexpected error:", error);
//       }
//     };

//     fetchData();
//   }, [rowId]);

//   // The component simply passes the imported configuration down to the Form component.
//   // The root of the problem is inside the <Form> component, which is not correctly
//   // interpreting the configuration provided in 'formFields'.
//   return (
//     <Form
//       formFields={formFields}
//       submitApi={submitApi}
//       formHeading={formHeading}
//       validationRules={validationRules}
//       calculationRules={calculationRules}
//       data={data}
//     />
//   );
// }

// export default CustomerForm;
















import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// The generic Form component that does all the heavy lifting.
import Form from "../../../site/forms/independent/form.js"; 

// All form configuration is imported from the module file.
// When module.js is updated, this component automatically gets the new configuration.
import {
  calculationRules,
  formFields, // This now includes the new vendor_type field configuration.
  formHeading,
  submitApi,
  validationRules,
} from "./module";

import { getToken } from "../../../../utils/auth"; 

const checkDuplicatePan = async (formData, rowId) => {
  const pan = (formData.pan_no || "").trim();
  if (!pan) return true;

  const token = getToken();
  const checkUrl = rowId
    ? `${submitApi}/check-duplicate-pan/${encodeURIComponent(pan)}?id=${rowId}`
    : `${submitApi}/check-duplicate-pan/${encodeURIComponent(pan)}`;

  const response = await fetch(checkUrl, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) return true;

  const { duplicates = [] } = await response.json();
  if (duplicates.length === 0) return true;

  const customerNames = duplicates.map((item) => item.name).join(", ");
  return window.confirm(
    `Warning: PAN number "${pan}" is already registered to: ${customerNames}.\n\nDo you want to proceed anyway?`
  );
};

function CustomerForm() {
  const [data, setData] = useState(null);
  const { rowId } = useParams();

  // This useEffect is for fetching data when editing an existing customer.
  // It remains unchanged.
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!rowId) return;
        const token = getToken();
        const response = await fetch(`${submitApi}/${rowId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const result = await response.json();
          // The result from the API will contain a vendor_type ID (e.g., "1").
          // The generic Form component will use this ID to pre-select the correct option in the dropdown.
          setData(result);
        } else {
          console.error("API Error:", response.statusText);
        }
      } catch (error) {
        console.error("Network or unexpected error:", error);
      }
    };

    fetchData();
  }, [rowId]);

  // The component simply passes the imported configuration down to the Form component.
  // The root of the problem is inside the <Form> component, which is not correctly
  // interpreting the configuration provided in 'formFields'.
  return (
    <Form
      formFields={formFields}
      submitApi={submitApi}
      formHeading={formHeading}
      validationRules={validationRules}
      calculationRules={calculationRules}
      data={data}
      redirectPath="/customers"
      redirectOnCreateOnly={false}
      onBeforeSubmit={(formData) => checkDuplicatePan(formData, rowId)}
    />
  );
}

export default CustomerForm;

